export default __webpack_public_path__ + "static/presence-eeb63d923a28cf10fbca17644977a1b2.png";